<script setup lang="ts">
    import { defaultRepeaterConverter } from "@/components/forms/groups/Repeater/helpers";
    import KRepeater from "@/components/forms/groups/Repeater/KRepeater.vue";
    import { Option } from "@/components/forms/inputs/Autocomplete/types";
    import { DIGITUM } from "@/tabs/Operation/utils";

    const converter = ({ value }: { value: { id?: string | Option | unknown; [key: string]: unknown }[] }) => {
        return defaultRepeaterConverter({ value, alwaysArray: true });
    };
</script>

<template>
    <KRepeater
        name="digitum"
        add-label="Lägg till digitum/digitus"
        remove-label="Ta bort digitum/digitus"
        :converter="converter"
        #default="{ index, model, validation }"
    >
        <KAutocomplete
            name="id"
            :options="DIGITUM"
            label="Digitum/Digitus"
            :value="model?.[index]?.id ?? null"
            :validation="validation"
        />
    </KRepeater>
</template>

<style scoped lang="scss"></style>
